// 账号
export const verifyAccount = async (rule, value) => {
    if (rule.required && !value) {
        return Promise.reject('请输入账号');
    }
    let ref = /^[A-Za-z0-9]+$/
    if (!ref.test(value)) {
        return Promise.reject('账号不能有中文');
    } else {
        return Promise.resolve();
    }
}

// 密码
export const verifyPwd = async (rule, value) => {
    if (rule.required && !value) {
        return Promise.reject('请输入密码');
    }
    let ref = /^(?![\da-z]+$)(?![\dA-Z]+$)(?![\d`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$)(?![a-zA-Z]+$)(?![a-z!`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$)(?![A-Z!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$)[\da-zA-z!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]{6,16}$/
    if (!ref.test(value)) {
        return Promise.reject('密码须6~16位的大写或小写字母、数字、特殊字符的任意三种组合');
    } else {
        return Promise.resolve();
    }
}

// 手机号
export const verifyPhone = async (rule, value) => {
    if (rule.required && !value) {
        return Promise.reject('请输入手机号');
    }
    let ref = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
    if (!ref.test(value)) {
        return Promise.reject('手机号格式不正确');
    } else {
        return Promise.resolve();
    }
}

// 价格
export const verifyPrice = async (rule, value) => {
    if (rule.required && !value) {
        return Promise.reject('请输入价格');
    }
    let ref = /^(?:0\.\d{0,1}[1-9]|(?!0)\d{1,6}(?:\.\d{0,1}[0-9])?)$/
    if (value && !ref.test(value)) {
        return Promise.reject('价格不正确，最多两位小数');
    } else {
        return Promise.resolve();
    }
}

// 邮箱
export const verifyEmail = async (rule, value) => {
    if (value) {
        let ref = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!ref.test(value)) {
            return Promise.reject('邮箱格式不正确');
        } else {
            return Promise.resolve();
        }
    } else {
        if (rule.required) {
            return Promise.reject('请输入邮箱');
        }
    }
}

// 身份证
export const verifyIdcard = async (rule, value) => {
    if (value) {
        let ref = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
        if (!ref.test(value)) {
            return Promise.reject('身份证格式不正确');
        } else {
            return Promise.resolve();
        }
    } else {
        if (rule.required) {
            return Promise.reject('请输入身份证');
        }
    }
}
